export const letterList = "LETTER_LIST";
export const letterTemplateContent = "LETTER_TEMPLATE_CONTENT";